import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { PageEnum } from '/@/enums/pageEnum';
import { RouteEnum } from '/@/enums/routeEnum';

// 决策记录(2026-08-25,老板拍板 #1):Phase 1 以管理员派单为主,
// 众包"认领"功能后端接口尚未实现(原页面调 /annotation/task/* 返回 404),
// 故下架认领页,直接重定向到主页;Phase 2 众包阶段再恢复实现。
const claim: AppRouteModule = {
  path: RouteEnum.CLAIM,
  name: 'Claim',
  component: LAYOUT,
  redirect: PageEnum.BASE_HOME,
  meta: {
    hideMenu: true,
    title: '认领任务',
  },
};

export default claim;
